/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer components {
  .formField {
    &:where(.vertical) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    &:where(.horizontal) {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .formLabel {
    display: block;
    cursor: default;
    font-size: var(--text-15, 0.9375rem);
    --tw-leading: calc(var(--spacing, 0.25rem) * 5.5);
    line-height: calc(var(--spacing, 0.25rem) * 5.5);
    --tw-font-weight: var(--font-weight-medium, 500);
    font-weight: var(--font-weight-medium, 500);
    color: var(--base-grey-900);
    &:last-child {
      margin-bottom: calc(var(--spacing, 0.25rem) * 0);
    }
    :where(.formField.vertical) & {
      margin-bottom: calc(var(--spacing, 0.25rem) * 3);
    }
    :where(.formField.vertical) & & {
      margin-bottom: calc(var(--spacing, 0.25rem) * 0);
    }
    :where(.formField.horizontal) & {
      margin-bottom: calc(var(--spacing, 0.25rem) * 0);
    }
    :where(.formField.vertical) &:has(&) {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
    }
    :where(.formField.horizontal) &:has(&) {
      display: flex;
      width: 100%;
      align-items: center;
    }
  }
  .formMessage {
    &:where(:not(.unstyled)) {
      margin: calc(var(--spacing, 0.25rem) * 0);
      font-size: var(--text-sm, 0.875rem);
      line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
      color: var(--base-grey-800);
      &:where(.error) {
        color: var(--base-red-500);
      }
    }
    * + & {
      margin-top: calc(var(--spacing, 0.25rem) * 2);
    }
  }
  .formFieldReset {
    &[aria-hidden="true"] {
      pointer-events: none;
    }
    &[aria-hidden="true"] {
      opacity: 0%;
    }
    &:not(.unstyled) {
      display: inline;
      cursor: pointer;
      font-size: var(--text-xs, 0.75rem);
      line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
      --tw-font-weight: var(--font-weight-normal, 400);
      font-weight: var(--font-weight-normal, 400);
      color: var(--color-primary-600);
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
      @media (prefers-reduced-motion: no-preference) {
        transition-property: color,opacity;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
        transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
      }
      &:hover {
        @media (hover: hover) {
          color: inherit;
        }
      }
      border-radius: var(--radius-xs, 0.125rem);
      --tw-ring-color: var(--color-primary-500);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-primary-500) 30%, transparent);
      }
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      &:focus-visible {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
      &[aria-disabled="true"] {
        cursor: not-allowed !important;
      }
      &[aria-disabled="true"] {
        color: var(--base-grey-500) !important;
      }
      &[aria-busy="true"] {
        cursor: wait !important;
      }
      &[aria-busy="true"] {
        color: var(--base-grey-500) !important;
      }
    }
  }
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
    }
  }
}
